import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Layout
import Header from './components/Header';
import Footer from './components/Footer';

// Public pages
import Home           from './pages/Home';
import Noticias       from './pages/Noticias';
import NoticiaDetalhe from './pages/NoticiaDetalhe';
import Projetos       from './pages/Projetos';
import Documentos     from './pages/Documentos';
import Galeria        from './pages/Galeria';
import QuemSomos      from './pages/QuemSomos';
import Contato        from './pages/Contato';

// Admin pages
import AdminLogin     from './pages/admin/AdminLogin';
import AdminLayout    from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminNoticias  from './pages/admin/AdminNoticias';
import AdminProjetos  from './pages/admin/AdminProjetos';
import AdminDocumentos from './pages/admin/AdminDocumentos';
import AdminGaleria   from './pages/admin/AdminGaleria';
import AdminMembros   from './pages/admin/AdminMembros';
import AdminContatos  from './pages/admin/AdminContatos';

// Styles
import './styles/global.css';
import './pages/admin/admin.css';

function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <div style={{ flex: 1 }}>{children}</div>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: { fontFamily: 'var(--font-body)', fontSize: '0.9rem' },
            success: { iconTheme: { primary: 'var(--laranja)', secondary: 'white' } },
          }}
        />
        <Routes>
          {/* ── Public ── */}
          <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
          <Route path="/quem-somos"      element={<PublicLayout><QuemSomos /></PublicLayout>} />
          <Route path="/projetos"        element={<PublicLayout><Projetos /></PublicLayout>} />
          <Route path="/noticias"        element={<PublicLayout><Noticias /></PublicLayout>} />
          <Route path="/noticias/:slug"  element={<PublicLayout><NoticiaDetalhe /></PublicLayout>} />
          <Route path="/documentos"      element={<PublicLayout><Documentos /></PublicLayout>} />
          <Route path="/galeria"         element={<PublicLayout><Galeria /></PublicLayout>} />
          <Route path="/contato"         element={<PublicLayout><Contato /></PublicLayout>} />

          {/* ── Admin Auth ── */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* ── Admin Protected ── */}
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index          element={<AdminDashboard />} />
            <Route path="noticias"   element={<AdminNoticias />} />
            <Route path="projetos"   element={<AdminProjetos />} />
            <Route path="documentos" element={<AdminDocumentos />} />
            <Route path="galeria"    element={<AdminGaleria />} />
            <Route path="membros"    element={<AdminMembros />} />
            <Route path="contatos"   element={<AdminContatos />} />
          </Route>

          {/* ── Fallback ── */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
